<template>
  <span>
    <div id="start_overlay">
        <span id="loading_section" v-show="$store.getters['app/loading']">
            <h1 id="loading_text">Aan het laden...
              <br>
              <span v-show="$store.getters['app/percentageLoad'] != null" v-html="$store.getters['app/percentageLoad']"></span>
            </h1>
        </span>

        <!-- App -->
        <img class="loaders" @load="addLoader()" src="./../assets/ossodresiosso/images/Asset 29.png">
        <img class="loaders" @load="addLoader()" src="./../assets/ossodresiosso/images/Asset 64.png">
        <img class="loaders" @load="addLoader()" src="./../assets/ossodresiosso/images/Asset 29.png">
        <img class="loaders" @load="addLoader()" :src="`./ossodresiosso/images/Asset ${cards[0].image_id}.png`">
        <img class="loaders" @load="addLoader()" :src="`./ossodresiosso/images/Asset ${cards[1].image_id}.png`">
        <img class="loaders" @load="addLoader()" :src="`./ossodresiosso/images/Asset ${cards[2].image_id}.png`">
        <img class="loaders" @load="addLoader()" :src="`./ossodresiosso/images/Asset ${cards[3].image_id}.png`">
        <img class="loaders" @load="addLoader()" :src="`./ossodresiosso/images/Asset ${cards[4].image_id}.png`">
        <img class="loaders" @load="addLoader()" :src="`./ossodresiosso/images/Asset ${cards[5].image_id}.png`">
        <img class="loaders" @load="addLoader()" :src="`./ossodresiosso/images/Asset ${cards[6].image_id}.png`">
        <img class="loaders" @load="addLoader()" :src="`./ossodresiosso/images/Asset ${cards[7].image_id}.png`">
        <img class="loaders" @load="addLoader()" :src="`./ossodresiosso/images/Asset ${cards[8].image_id}.png`">
        <img class="loaders" @load="addLoader()" :src="`./ossodresiosso/images/Asset ${cards[9].image_id}.png`">
        <img class="loaders" @load="addLoader()" :src="`./ossodresiosso/images/Asset ${cards[10].image_id}.png`">
        <img class="loaders" @load="addLoader()" :src="`./ossodresiosso/images/Asset ${cards[11].image_id}.png`">
        <img class="loaders" @load="addLoader()" :src="`./ossodresiosso/images/Asset ${cards[12].image_id}.png`">
        <img class="loaders" @load="addLoader()" :src="`./ossodresiosso/images/Asset ${cards[13].image_id}.png`">
        <img class="loaders" @load="addLoader()" :src="`./ossodresiosso/images/Asset ${cards[14].image_id}.png`">
        <img class="loaders" @load="addLoader()" :src="`./ossodresiosso/images/Asset ${cards[15].image_id}.png`">
        <img class="loaders" @load="addLoader()" :src="`./ossodresiosso/images/Asset ${cards[16].image_id}.png`">
        <img class="loaders" @load="addLoader()" :src="`./ossodresiosso/images/Asset ${cards[17].image_id}.png`">
        <img class="loaders" @load="addLoader()" :src="`./ossodresiosso/images/Asset ${cards[18].image_id}.png`">
        <img class="loaders" @load="addLoader()" :src="`./ossodresiosso/images/Asset ${cards[19].image_id}.png`">
        <img class="loaders" @load="addLoader()" :src="`./ossodresiosso/images/Asset ${cards[20].image_id}.png`">

        <img class="loaders" @load="addLoader()" src="./../assets/ossodresiosso/images/Asset 49.png">
        <img class="loaders" @load="addLoader()" src="./../assets/ossodresiosso/images/Asset 51_.png">
        <img class="loaders" @load="addLoader()" src="./../assets/ossodresiosso/images/Asset 30.png">
        <img class="loaders" @load="addLoader()" src="./../assets/ossodresiosso/images/Asset 57_.png">
        <img class="loaders" @load="addLoader()" src="./../assets/ossodresiosso/images/Asset 48.png">
        <!-- Also preload videos -->
        <!-- <video id="video_1" loop playsinline>
          <source src="./../assets/background.mp4" type="video/mp4" />
        </video> -->

    </div>
  </span>
</template>

<script>


export default {
  name: "Preload",

  data() {
    return {
      cards: [
        {
          id: 1,
          image_id: 52,
        },
        {
          id: 2,
          image_id: 51,
        },
        {
          id: 3,
          image_id: 50,
        },
        {
          id: 4,
          image_id: 53,
        },
        {
          id: 5,
          image_id: 57,
        },
        {
          id: 6,
          image_id: 62,
        },
        {
          id: 7,
          image_id: 63,
        },
        {
          id: 8,
          image_id: 55,
        },
        {
          id: 9,
          image_id: 58,
        },
        {
          id: 10,
          image_id: 59,
        },
        {
          id: 11,
          image_id: 56,
        },
        {
          id: 12,
          image_id: 54,
        },
        {
          id: 13,
          image_id: 60,
        },
        {
          id: 14,
          image_id: 61,
        },
        {
          id: 15,
          image_id: 70,
        },
        {
          id: 16,
          image_id: 71,
        },
        {
          id: 17,
          image_id: 72,
        },
        {
          id: 18,
          image_id: 78,
        },
        {
          id: 19,
          image_id: 81,
        },
        {
          id: 20,
          image_id: 85,
        },
        {
          id: 21,
          image_id: 84
        },
      ],
      loader: 0
    };
  },

  methods: {
    addLoader() {
      this.loader++;
    }
  },

  watch: {
    loader(loaded) {
      /**
       * Be sure that this is the exact amount of assets to be loaded
       */
      const total_elements = document.getElementsByClassName('loaders').length;

      this.$store.dispatch('app/asyncUpdatePercentageLoad', {
          percentage_load: parseInt( ( loaded / total_elements ) * 100 ) + ' / 100',
      });

      // If critical assets are loaded, show start button
      if ( loaded == total_elements ) {
        this.$store.dispatch('app/asyncUpdateStarted', {
          started: true,
        });
        this.$store.dispatch('app/asyncUpdateLoading', {
          loading: false,
        });
        this.$router.push('/');

        this.$store.dispatch('app/asyncUpdatePercentageLoad', {
          percentage_load: null,
        });
      }
    }
  },
};
</script>

<style>
  #start_overlay {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    background-color: #b08f6c;
  }

  .loaders {
    display: none;
  }

  #loading_text {
    font-family: 'LuckiestGuy';
    margin-top: 8%;
    width: 100%;
    height: 20%;
    left: 0%;
    color: white;
    font-size: 5vw;
    text-align: center;
    font-size: 4em;
    color: white;
    z-index: 100;
  }

  #loading_section {
    z-index: 100;
    position: fixed;
    width: 100%;
  }
</style>
